'use strict';

import $ from 'jquery';
import { initOnboarding } from '@/js/modules/onboarding';
import { toggleDiscussionPanel } from '@/js/application/messages';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(function () {
    if ($('body').is('#project')) {
      $(document).on('submit', '.accept-project-form', (e) => {
        const $submit = $(e.target).find('button[type=submit]');
        $submit.addClass('button-loading').prop('disabled', true);

        return true;
      });
    } else if ($('body').is('#projects-dashboard')) {
      if ($('.onboarding-steps-container').data('auto-play') === true) {
        initOnboardingDashboard();
      }
    }
  });

  function initOnboardingDashboard() {
    const config = {
      stepOptions: [
        { element: '#project-details', position: 'right' },
        { element: '#contact-details', position: 'bottom' },
        { element: '#project-notes', position: 'left' },
        { element: '#requires-follow-up', position: 'top' },
        { element: '#design-boards', position: 'top' },
        { element: '#financial-summary', position: 'top' },
      ],
    };

    let panelClosed = 0;
    initOnboarding({
      stepOptions: config.stepOptions,
      onStart() {
        if ($('.discussion-panel').hasClass('discussion-panel--active')) {
          toggleDiscussionPanel(false, true);
          panelClosed = 1;
        }
      },
      onBeforeChange() {},
      onComplete() {
        if (panelClosed === 1) {
          toggleDiscussionPanel(true);
        } else {
          toggleDiscussionPanel(false);
        }
        window.scrollTo(0, 0);
      },
    });
  }

  $(document).on('click', '.dropdown-menu__link--dashboard-walkthrough', (e) => {
    e.preventDefault();
    initOnboardingDashboard();
  });
});
